import * as Cookies from "js-cookie";
import React from 'react';

export const setAvaliacaoCookie = (Avaliacao) => {
  Cookies.remove("Avaliacao");
  Cookies.set("Avaliacao", Avaliacao, { expires: 0.08 });
};

export const getAvaliacaoCookie = () => {
  const AvaliacaoCookie = Cookies.get("Avaliacao");
  if (AvaliacaoCookie === undefined) {
    return null;
  } else {
    try{
    return JSON.parse(AvaliacaoCookie);
    }catch{
      return null;
    }
  }
};

export const AvaliacaoContext = React.createContext(getAvaliacaoCookie());

export const setAvaliacaoConsultaCookie = (Avaliacao) => {
  Cookies.remove("AvaliacaoConsultaCookie");
  Cookies.set("AvaliacaoConsultaCookie", Avaliacao, { expires: 0.08 });
};

export const getAvaliacaoConsultaCookie = () => {
  const AvaliacaoCookie = Cookies.get("AvaliacaoConsultaCookie");
  if (AvaliacaoCookie === undefined) {
    return null;
  } else {
    try{
    return JSON.parse(AvaliacaoCookie);
    }catch{
      return null;
    }
  }
};

export const AvaliacaoConsultaContext = React.createContext(getAvaliacaoConsultaCookie());